import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-vendor-note',
    templateUrl: './breadcrumb.vendor.note.component.html'
})

export class BreadcrumbVendorNoteComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() vendorId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
